<template>
  <div id="payment-history">
    <modal @closeModal="closeModal" v-if="showTransactionDetailsModal" size="modal-lg">
      <div slot="header">
        <h4 class="modal-title">Transaction Details</h4>
      </div>
      <div slot="body">
        <transaction-details :receipt-no="receiptNo"></transaction-details>
      </div>
    </modal>
    <vue-good-table :columns="columns" :search-options="{enabled: true, placeholder:'Search'}" :rows="rows"
                    :paginationOptions="{ enabled: true }"
                    :lineNumbers="data.length ? true : false"
                    styleClass="table table-striped table-bordered m--margin-top-15">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'receiptNo'">
          <a href="javascript: void(0)" @click="getTransactionDetails(props.row.receiptNo)">
            {{ props.row.receiptNo }}
          </a>
        </span>
        <span v-else-if="props.column.field == 'amount'">
          KES {{ formatNumber(props.row.amount) }}
        </span>
        <span v-else-if="props.column.field == 'download'" @click="downloadStickers(props.row.receiptNo)"
              class="pointer">
          <i class="fa text-dark fa-file-pdf-o"></i>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <div slot="emptystate">
        No payments to display
      </div>
      <div slot="table-actions">
        <button class="btn btn-primary" @click="loadPayHistory">
          <i class="fa fa-refresh" :class="{'fa-spin': loading }"></i>
        </button>
      </div>
    </vue-good-table>
  </div>
</template>
<script>
  import helpers from "../../../../helpers";
  import api from "../../../../api";
  import config from "../../../../config";
  import transactionDetails from "./TransactionDetails";
  import modal from "../../../Modal"

  export default {
    name: "parking-payment-history",
    props: ["data"],
    data: function () {
      return {
        loading: false,
        receiptNo: "",
        payments: this.data,
        token: this.$store.state.token,
        showTransactionDetailsModal: false,
        columns: [
          {
            label: "Receipt No.",
            field: "receiptNo"
          },
          {
            label: "Payment Method",
            field: "paymentMode"
          },
          {
            label: "Amount",
            field: "amount"
          },
          {
            label: "Payment Date",
            field: "paymentDate",
            type: "date",
            dateInputFormat: "YYYY-MM-DD HH:mm:ss",
            dateOutputFormat: config.dateFormat
          },
          {
            label: "Download",
            field: "download"
          }
        ]
      };
    },
    components: {
      modal,
      transactionDetails
    },
    computed: {
      rows: function () {
        return this.payments;
      }
    },
    methods: {
      formatNumber(number) {
        return helpers.formatNumber(number);
      },
      loadPayHistory() {
        const txType = "get-customer-payment-history-seasonal-parking";
        let data = {
          token: this.token,
          countyId: this.countyId
        };
        this.loading = true;
        api
          .request(txType, data)
          .then(response => {
            this.loading = false;
            if (response.data.status === "00") {
              this.payments = response.data.paymentHistory;
            } else {
              console.log(response.data.message);
            }
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      },
      getTransactionDetails(receiptNo) {
        document.body.classList.add("modal-open");
        this.showTransactionDetailsModal = true;
        this.receiptNo = receiptNo;
      },
      closeModal(){
        document.body.classList.remove("modal-open");
        this.showTransactionDetailsModal = false;
      },
      downloadStickers(receiptNo) {
        const txType = "download-stickers";
        let data = {
          token: this.token,
          receiptNo: receiptNo
        };
        api
          .request(txType, data)
          .then(response => {
            if (response.data.status === "00") {
              let form = document.createElement("form");
              form.setAttribute("action", response.data.url);
              form.setAttribute("method", "POST");
              document.body.appendChild(form);
              form.submit();
            } else {
              console.log(response.data.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/services/seasonal_parking/datatables/PaymentHistory.vue